











































































































import { Component, Prop, Vue, Mixins } from "vue-property-decorator";
import PreviewModal from "./PreviewModal.vue";
import LineItemFrameSelect from "./LineItemFrameSelect.vue";
import { editorUrl, backendUrl } from "../util/config";
import * as types from "../types/types";
import * as cartProvider from "../providers/CartProvider";
import { FrameStatus } from "../types/print";
import { formatCurrency, isUSLocale } from "@/util/getCurrency";

@Component({
  components: {
    PreviewModal,
    LineItemFrameSelect,
  },
})
export default class LineItem extends Vue {
  @Prop() item!: types.LineItem;

  isPreviewModalVisible = false;
  isDeleted = false;
  isImgLoaded = false;
  formatCurrency = formatCurrency;

  getDiscountPercent() {
    return +this.item.discountPercent || 0.0;
  }
  showPreviewModal() {
    this.isPreviewModalVisible = true;
  }
  closePreviewModal() {
    this.isPreviewModalVisible = false;
  }
  removePosterFromCart() {
    cartProvider.deleteItemfromCart(this.item.product.productId);
  }
  goTo(url) {
    window.location.href = url;
  }
  get finalPrice() {
    return this.item.priceInUserCurrency * (1 - this.getDiscountPercent());
  }
  get discount(): number {
    return this.getDiscountPercent() * 100;
  }
  get imageUrl(): string {
    const productRoute =
      this.item.product.type === types.ProductType.starmap
        ? "starmap-legacy"
        : this.item.product.type;
    return isUSLocale
      ? `${backendUrl}/${productRoute}/${this.item.product.productId}/preview/18x24in.jpg`
      : `${backendUrl}/${productRoute}/${this.item.product.productId}/preview.jpg`;
  }
  get modifyPosterUrl(): string {
    return `${editorUrl}/?edit=true&posterId=${this.item.product.productId}`;
  }
  get titleKey(): string {
    if (isUSLocale) {
      return this.$t(
        this.item.product.type + ":product." + this.item.print.type + ".titleUS"
      );
    }
    return this.$t(
      this.item.product.type + ":product." + this.item.print.type + ".title"
    );
  }
  get frameColor(): string {
    if (
      this.item.print.printProperties != null &&
      this.item.print.printProperties.frameColor != null
    ) {
      return this.item.print.printProperties.frameColor;
    }
  }
  get showFrameSelector(): boolean {
    if (!this.item.print.frameProperties) {
      return false;
    }
    if (this.item.product.type !== "starmap") {
      return true;
    }
    return (
      this.item.print.type === types.PrintType.poster30x40cm ||
      this.item.print.type === types.PrintType.posterFramed30x40cm
    );
  }

  get dynamicColspan() {
    if (window.matchMedia("(max-width: 30em)").matches) {
      return 2;
    } else {
      return 1;
    }
  }
}
